import React from "react";
import {isToday, isDateOneBeforeDateTwo} from "../../../utils/dateUtils";
import "./eventDateHeadingFormat.sass";
import classNames from "classnames";

export interface IEventDateHeadingFormatProps {
  date: Date;
  isReleaseDate?: boolean;
  isFutureReleaseDate?: boolean;
}

const EventDateHeadingFormat: React.FC<IEventDateHeadingFormatProps> = ({
  date,
  isReleaseDate,
  isFutureReleaseDate
}) => {
  let formatter = new Intl.DateTimeFormat("en", {
    weekday: "short",
    day: "numeric",
    month: "short"
  });

  let dateParts = formatter.formatToParts(date);
  let weekDay = dateParts.find((d) => d.type === "weekday")?.value;
  let dateNumber = dateParts.find((d) => d.type === "day")?.value;
  let isPast = isDateOneBeforeDateTwo(date, new Date());
  return (
    <div
      className={classNames(
        "eventDateHeading row no-gutters justify-content-center align-items-center ",
        {
          "unreleased-header-background-summary": isReleaseDate,
          "future-unrelese": isFutureReleaseDate
        }
      )}
    >
      <div className="event-day-number">
        <div
          className={classNames({
            "is-today-day-number": isToday(date),
            "is-past": isPast
          })}
        >
          {dateNumber}
        </div>
      </div>
      <div
        className={classNames("pl-2", {
          "is-today-week": isToday(date),
          "is-past": isPast
        })}
      >
        {weekDay}
      </div>
    </div>
  );
};

export default EventDateHeadingFormat;
